export const GET_PLC_STATUS = "GET_PLC_STATUS";
export const GET_PLC_STATUS_SUCCESS = "GET_PLC_STATUS_SUCCESS";
export const GET_PLC_STATUS_ERROR = "GET_PLC_STATUS_ERROR";
